import * as http from 'utils/http';
import { adaptFieldFromURL } from 'utils/converters';
import {
  getCurrentCarrier,
  getVehicleById,
  getDriverById,
} from 'redux/modules/carrier-section/selectors';

const createRequest = (dedicatedContract) => ({
  type: 'CREATE_DEDICATED_CONTRACT_REQUEST',
  dedicatedContract,
});

const createDone = (dedicatedContract) => ({
  type: 'CREATE_DEDICATED_CONTRACT_DONE',
  dedicatedContract,
});

const createCancel = (error) => ({
  type: 'CREATE_DEDICATED_CONTRACT_CANCEL',
  error,
});

const updateRquest = (dedicatedContract) => ({
  type: 'UPDATE_DEDICATED_CONTRACT_REQUEST',
  dedicatedContract,
});

const updateDone = (dedicatedContract) => ({
  type: 'UPDATE_DEDICATED_CONTRACT_DONE',
  dedicatedContract,
});

const updateCancel = (error) => ({
  type: 'UPDATE_DEDICATED_CONTRACT_CANCEL',
  error,
});

const loading = () => ({
  type: 'LOAD_DEDICATED_CONTRACTS_REQUEST',
});

const done = (dedicatedContracts) => ({
  type: 'LOAD_DEDICATED_CONTRACTS_DONE',
  dedicatedContracts,
});

const cancel = (error) => ({
  type: 'LOAD_DEDICATED_CONTRACTS_CANCEL',
  error,
});

export const filterDedicatedContracts = (filters) => ({
  type: 'FILTER_DEDICATED_CONTRACTS',
  filters,
});

export const setContractLoading = (id, loading) => ({
  type: 'SET_CONTRACT_LOADING',
  payload: {
    id,
    loading,
  },
});

const getIdFromUrl = (url) => (url ? parseInt(url.split('/')[url.split('/').length - 2]) : '');
const fetchDriver = async (id, config) => await http.get(`${config.API_URL}drivers/?${id}`);
const fetchVehicle = async (id, config) => await http.get(`${config.API_URL}vehicles/?${id}`);

export const fetchDedicatedContracts = ({ carrier, active_at } = {}) => {
  return (dispatch, getState, config) => {
    dispatch(loading());
    const query = ['page_size=0']
      .concat(carrier ? [`carrier=${carrier.id}`] : [])
      .concat(active_at ? [`active_at=${active_at}`] : [])
      .join('&');
    return http
      .get(`${config.API_URL}dedicated_contracts/?${query}`)
      .catch((err) => {
        dispatch(cancel(err));
        throw err;
      })
      .then((obj) => {
        return obj.map((contract) => {
          const state = getState();
          const carrier = getCurrentCarrier(state);
          const driverId = getIdFromUrl(contract.driver);
          const driver = getDriverById(state, driverId) || fetchDriver(driverId, config);
          const vehicleId = getIdFromUrl(contract.vehicle);
          const vehicle = getVehicleById(state, vehicleId) || fetchVehicle(vehicleId, config);
          if (carrier && driver && vehicle) {
            return { ...contract, carrier, driver, vehicle };
          } else {
            const err = 'Unable to find driver or vehicle in currentCarrier';
            dispatch(cancel(err));
            throw err;
          }
        });
      })
      .then((dedicatedContracts) => dispatch(done(dedicatedContracts)));
  };
};

export const populateOne = (dedicatedContract) => {
  return Promise.resolve(dedicatedContract)
    .then(adaptFieldFromURL('vehicle'))
    .then(adaptFieldFromURL('driver'))
    .then(adaptFieldFromURL('carrier'));
};

export const createDedicatedContract = (dedicatedContract) => {
  return (dispatch, getState, config) => {
    dispatch(createRequest(dedicatedContract));

    return http
      .post(`${config.API_URL}dedicated_contracts/`, {
        ...dedicatedContract,
      })
      .then(populateOne)
      .catch((err) => {
        dispatch(createCancel(err));
        throw err;
      })
      .then((dedicatedContract) => dispatch(createDone(dedicatedContract)));
  };
};

export const updateExceptionsDedicatedContract = (dedicatedContract, exceptions) => {
  return (dispatch) => {
    dispatch(updateRquest(dedicatedContract));

    return http
      .put(dedicatedContract.update_exceptions, {
        exceptions,
      })
      .then(populateOne)
      .catch((err) => {
        dispatch(updateCancel(err));
        throw err;
      })
      .then((dedicatedContract) => dispatch(updateDone(dedicatedContract)));
  };
};

export const finishDedicatedContract = (dedicatedContract, end_date) => {
  return (dispatch) => {
    dispatch(updateRquest(dedicatedContract));

    return http
      .put(dedicatedContract.finish_contract, { end_date })
      .then(populateOne)
      .catch((err) => {
        dispatch(updateCancel(err));
        throw err;
      })
      .then((dedicatedContract) => dispatch(updateDone(dedicatedContract)));
  };
};
